<!-- Reference view — see AGENTS.md "Reference components". -->
<template>
  <AppShell title="Ansökningar">
    <template #actions>
      <p v-if="!isLoading" class="text-subtle">{{ tableModel.pagination.totalItems }} ansökningar</p>
    </template>

    <DistributorApplicationFilters :filters="filters" @filters="handleUpdateFilters" />

    <p v-if="error" class="error-text error-container">{{ error.message }}</p>

    <AppCard no-padding>
      <DistributorApplicationsTable :model="tableModel" />
    </AppCard>
  </AppShell>
</template>

<script setup lang="ts">
import { AppCard } from '@staff/ui'

import AppShell from '@/components/AppShell.vue'
import { useDistributorApplicationSearch } from '@/composables/distributorApplicationSearch'

import DistributorApplicationFilters from './applications/components/DistributorApplicationFilters.vue'
import DistributorApplicationsTable from './applications/components/DistributorApplicationsTable.vue'

const { filters, tableModel, isLoading, error, handleUpdateFilters } = useDistributorApplicationSearch()
</script>
<style lang="scss" scoped>
.error-container {
  margin-bottom: var(--space-12);
}
</style>
